import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";
import Report from "../Report";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import { dateReportFormatter, dateTimeReportFormatter } from "../../fomatters/DateFormatter";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import InputSelect from "../InputSelect";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function AccountChanges() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [account, setAccount] = useState("");
  const onAccountChange = useCallback(
    (event) => setAccount(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [accountType, setAccountType] = useState(0);
  const onAccountTypeChange = useCallback(
    (event) => setAccountType(Number(event.target.value)),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <TextField
          variant="outlined"
          label="Account"
          type="text"
          value={account}
          size="small"
          onChange={onAccountChange}
          InputLabelProps={{ shrink: true }}
        />
        <div>
          <SubGroup title="Account Of">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={accountType}
                onChange={onAccountTypeChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Players"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Agents"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Users"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>

        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
      </div>
      <Report
        title="Account Changes Report"
        getUrl={() => "/Reports/Report_Account_Changes_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Book: book,
          Account: account,
          AccountType: accountType,
          Distributor: distributor,
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="account">
          Account
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="fieldName">
          Field Changed
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="oldValue">
          Before
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="newValue">
          After
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="placedDate"
          dataFormat={dateTimeReportFormatter}
        >
          Change Date
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="loginName">
          Changed By
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default AccountChanges;
